import PrivateRoute from './PrivateRouteContainer'

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js